import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { PressReleaseService } from '../services/press-release.service';
import { PressRelease } from '../models/press-release';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-press-release-form',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './press-release-form.component.html',
  styleUrls: ['./press-release-form.component.css']
})
export class PressReleaseFormComponent {
  pressReleaseForm: FormGroup;

  constructor(private fb: FormBuilder, private pressReleaseService: PressReleaseService) {
    this.pressReleaseForm = this.fb.group({
      title: ['', [Validators.required, Validators.minLength(5)]],
      date: ['', Validators.required],
      summary: ['', [Validators.required, Validators.maxLength(200)]],
      content: ['', Validators.required],
      link: ['']
    });
  }

  onSubmit(): void {
    if (this.pressReleaseForm.valid) {
      const newRelease: PressRelease = this.pressReleaseForm.value;
      this.pressReleaseService.addPressRelease(newRelease).subscribe(() => {
        this.pressReleaseForm.reset();
        alert('Press release added successfully!');
      });
    }
  }
}
